import { render, staticRenderFns } from "./BaseBigNumber.vue?vue&type=template&id=7b909951&scoped=true"
import script from "./BaseBigNumber.vue?vue&type=script&lang=js"
export * from "./BaseBigNumber.vue?vue&type=script&lang=js"
import style0 from "./BaseBigNumber.vue?vue&type=style&index=0&id=7b909951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b909951",
  null
  
)

export default component.exports